import { Box, Typography, Button } from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import PeopleIcon from '@mui/icons-material/People'
import logo from '../../assets/rounded_logo.svg'

export default function UtilRoommatesFrame() {
  return (
    <Box sx={{
      position: 'relative',
      width: 280,
      height: 560,
      bgcolor: '#000',
      borderRadius: 6,
      p: 1,
      boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
    }}>
      {/* iPhone Frame */}
      <Box sx={{
        width: '100%',
        height: '100%',
        bgcolor: 'white',
        borderRadius: 5,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Header */}
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 1.5,
          pt: 1,
          pb: 0.5
        }}>
          <Box
            component="img"
            src={logo}
            alt="HeyyProperty"
            sx={{
              height: 40,
              width: 'auto',
              maxWidth: '60px',
              marginTop: '5px'
            }}
          />
          <Box sx={{
            border: '1px solid',
            borderColor: 'grey.400',
            borderRadius: '9999px',
            px: 1.5,
            py: 0.5,
            fontSize: '0.5rem',
            fontWeight: 600,
            color: 'grey.800',
            cursor: 'default'
          }}>
            Leave Household
          </Box>
        </Box>

        {/* Scrollable Content */}
        <Box sx={{ flex: 1, overflow: 'hidden', px: 1.5, pb: 1 }}>
          {/* Current Roommates Card */}
          <Box sx={{
            border: '1px solid',
            borderColor: 'grey.200',
            borderRadius: '12px',
            p: 1.5,
            mb: 1.5
          }}>
            <Typography sx={{ fontWeight: 700, fontSize: '0.875rem', mb: 1 }}>
              Current Roommates
            </Typography>

            {/* You */}
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 0.75,
              borderBottom: '1px solid',
              borderColor: 'grey.100'
            }}>
              <Box>
                <Typography sx={{ fontSize: '0.625rem', fontWeight: 600, color: 'grey.900' }}>You</Typography>
                <Typography sx={{ fontSize: '0.5rem', color: 'grey.500' }}>Move-in: Feb 1, 2026</Typography>
              </Box>
              <Box sx={{
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: '9999px',
                px: 1,
                py: 0.25,
                fontSize: '0.5rem',
                fontWeight: 600,
                color: 'grey.700',
                cursor: 'default'
              }}>
                Remove
              </Box>
            </Box>

            {/* John Snow */}
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 0.75,
              borderBottom: '1px solid',
              borderColor: 'grey.100'
            }}>
              <Box>
                <Typography sx={{ fontSize: '0.625rem', fontWeight: 600, color: 'grey.900' }}>John Snow</Typography>
                <Typography sx={{ fontSize: '0.5rem', color: 'grey.500' }}>Move-in: Feb 9, 2026</Typography>
              </Box>
              <Box sx={{
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: '9999px',
                px: 1,
                py: 0.25,
                fontSize: '0.5rem',
                fontWeight: 600,
                color: 'grey.700',
                cursor: 'default'
              }}>
                Remove
              </Box>
            </Box>

            {/* Jacob Valkerie */}
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 0.75
            }}>
              <Box>
                <Typography sx={{ fontSize: '0.625rem', fontWeight: 600, color: 'grey.900' }}>Jacob Valkerie</Typography>
                <Typography sx={{ fontSize: '0.5rem', color: 'grey.500' }}>Move-in: Feb 4, 2026</Typography>
              </Box>
              <Box sx={{
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: '9999px',
                px: 1,
                py: 0.25,
                fontSize: '0.5rem',
                fontWeight: 600,
                color: 'grey.700',
                cursor: 'default'
              }}>
                Remove
              </Box>
            </Box>

            {/* Add new roommate button */}
            <Button
              fullWidth
              variant="contained"
              disableElevation
              sx={{
                bgcolor: 'black',
                color: 'white',
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.625rem',
                borderRadius: '9999px',
                py: 0.75,
                mt: 1.5,
                '&:hover': { bgcolor: 'grey.800' }
              }}
            >
              Add new roommate
            </Button>
          </Box>

          {/* Past Roommates Card */}
          <Box sx={{
            border: '1px solid',
            borderColor: 'grey.200',
            borderRadius: '12px',
            p: 1.5
          }}>
            <Typography sx={{ fontWeight: 700, fontSize: '0.875rem', mb: 0.5 }}>
              Past Roommates
            </Typography>
            <Typography sx={{ fontSize: '0.625rem', color: 'grey.500' }}>
              No past roommates.
            </Typography>
          </Box>
        </Box>

        {/* Bottom Navigation */}
        <Box sx={{
          borderTop: '1px solid',
          borderColor: 'grey.200',
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          py: 0.75,
          px: 1
        }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.25 }}>
            <HomeIcon sx={{ fontSize: '1rem', color: 'grey.500' }} />
            <Typography sx={{ fontSize: '0.5rem', color: 'grey.500' }}>Home</Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.25 }}>
            <ReceiptLongIcon sx={{ fontSize: '1rem', color: 'grey.500' }} />
            <Typography sx={{ fontSize: '0.5rem', color: 'grey.500' }}>Bills</Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.25 }}>
            <PeopleIcon sx={{ fontSize: '1rem', color: 'grey.900' }} />
            <Typography sx={{ fontSize: '0.5rem', fontWeight: 700, color: 'grey.900' }}>Roommates</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
